$(document).ready(function () {

  $(".generalmessage").prependTo("header");
});
